import React from 'react';
import StateSocialWorkerJobsPage from './StateSocialWorkerJobsPage';

const NewYorkSocialWorkerJobs = () => {
  return (
    <StateSocialWorkerJobsPage
      stateName="New York"
      stateAbbr="NY"
      metaTitle="New York Social Worker Jobs (LMSW, LCSW, MSW) | INeedASocialWorker"
      metaDescription="Find New York social worker jobs in hospitals, schools, behavioral health, and community agencies. Search NYC, Buffalo, Rochester jobs. Apply fast."
      cities={[
        "New York City",
        "Buffalo",
        "Rochester",
        "Albany",
        "Syracuse",
        "Yonkers",
        "White Plains",
        "New Rochelle",
        "Binghamton",
        "Utica",
        "Ithaca",
        "Poughkeepsie",
        "Long Island"
      ]}
      stateDescription="Looking for social work jobs in New York? The Empire State offers diverse opportunities in major hospital systems, school districts, mental health agencies, and community organizations."
      faqItems={[
        {
          question: "What types of social work jobs are hiring in New York right now?",
          answer: "New York employers commonly hire for hospital social work, school-based services, behavioral/mental health, child welfare, and community organizations. NYC has the largest concentration of positions."
        },
        {
          question: "What license do I need to practice social work in New York?",
          answer: "New York requires the LCSW (Licensed Clinical Social Worker) for clinical practice and the LMSW (Licensed Master Social Worker) for non-clinical roles. New York also offers the LCSW-R for private practice."
        },
        {
          question: "What is the average salary for social workers in New York?",
          answer: "New York social workers earn among the highest salaries nationwide, typically ranging from $55,000-$85,000+ depending on setting. NYC and surrounding areas command premium salaries to offset higher living costs."
        },
        {
          question: "How do I apply faster?",
          answer: "Create your profile, upload your resume, and use one-click apply when available through our SW Express Apply™ feature."
        }
      ]}
    />
  );
};

export default NewYorkSocialWorkerJobs;
